// arrayOrStringToString
//
// Take an array of strings, concatenate them
//
// Used to stitch together multi-line strings stored in JSON file
//

export default (stringOrArray) => {
  if (!stringOrArray) return '';

  if (Array.isArray(stringOrArray)) {
    return stringOrArray.reduce(
      (prev, curr, index) => ((index)
        ? `${prev} ${curr}`
        : curr),
      '',
    );
  }

  return stringOrArray;
};
